import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment.prod';
import { UpdateCartAfterLogin } from 'src/_lib/interfaces/request-interfaces/cart.interface';

@Injectable({
  providedIn: 'root'
})
export class OrdermapService {

  private endpoint: string = environment.apiUrl;

  constructor(private http: HttpClient) {}


  // updateOrder( data:any): Observable<any> {
  //   return this.http.put(`${this.endpoint}orders`, data);
  // }

  cartReorder(reorderData: { merge_order: string }): Observable<any> {
    return this.http.post(`${this.endpoint}merge-order`, reorderData);
  }
}
